import React, { useState, useEffect, useContext } from 'react';
import NavBar from '../components/NavBar';
import BottomBar from '../components/BottomBar';
import { LanguageContext } from '../LanguageContext';
import axios from 'axios';
import '../components/Pdf.css';
const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function OTFoundations() {
    const [pdfUrl, setPdfUrl] = useState(null);
    const { t, setLanguage } = useContext(LanguageContext);

    useEffect(() => {
        const desiredPdf = 'OTFoundations_1.pdf';

        fetch(`${BASE_URL}/api/pdf?name=${encodeURIComponent(desiredPdf)}`)
            .then(response => response.blob())
            .then((blob) => {
                // Create a blob URL for the PDF blob
                const url = URL.createObjectURL(blob);
                setPdfUrl(url);
            })
            .catch((error) => {
                console.error("Error fetching PDF:", error);
            });
    }, []);

    return (
        <>
            <NavBar />
            {pdfUrl ? (
                <iframe
                    className="pdf-frame"
                    src={pdfUrl}
                    title="PDF Viewer"
                    allow="fullscreen"
                />
            ) : (
                <div className="loading-text">
                    {/* <div className="spinner"></div> */}
                    <p>{t('pdfloading')}</p>
                </div>
            )}
            {/* <BottomBar /> */}
        </>
    );
};

export default OTFoundations;